import React from 'react';
type DecorProps = {
  className?: string;
};

/** Doble hélice de ADN — decorativa. */
export function DnaHelix({
  className = ''
}: DecorProps) {
  const rungs = Array.from({
    length: 9
  }, (_, index) => 24 + index * 19);
  return <svg viewBox="0 0 80 200" fill="none" aria-hidden="true" className={className} data-id="element-17" data-mp="3fxfxiydu7gkf">
      <path d="M22 4C58 30 58 58 22 84c-36 26-36 54 0 80 36 26 36 26 0 32" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.75" data-id="element-18" data-mp="3kvzhwucs8kao" />
      <path d="M58 4C22 30 22 58 58 84c36 26 36 54 0 80-36 26-36 26 0 32" stroke="currentColor" strokeWidth="3" strokeLinecap="round" opacity="0.45" data-id="element-19" data-mp="3azwhpu1hqvqd" />
      {rungs.map(y => <line key={y} x1="24" y1={y} x2="56" y2={y} stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.35" data-id="element-20" data-mp="326szl8fwhupe" />)}
    </svg>;
}

/** Árbol transgeneracional — decorativo. */
export function TreeOfLife({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 200" fill="none" aria-hidden="true" className={className} data-id="element-21" data-mp="2k75s4h8mtnqe">
      <path d="M60 196v-92" stroke="currentColor" strokeWidth="4" strokeLinecap="round" opacity="0.75" data-id="element-22" data-mp="2y8i46hko9570" />
      <path d="M60 150c-14 10-22 24-24 42M60 150c14 10 22 24 24 42M60 166c-8 6-14 16-16 30M60 166c8 6 14 16 16 30" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" opacity="0.4" data-id="element-23" data-mp="2u653w8op1zhm" />
      <path d="M60 108c-16-8-26-20-30-34M60 108c16-8 26-20 30-34M60 88c-12-6-20-16-24-28M60 88c12-6 20-16 24-28" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" opacity="0.5" data-id="element-24" data-mp="21jka71kqxbaw" />
      <circle cx="60" cy="52" r="30" fill="currentColor" opacity="0.28" data-id="element-25" data-mp="1msl6a3uuvaxn" />
      <circle cx="32" cy="70" r="17" fill="currentColor" opacity="0.22" data-id="element-26" data-mp="1mqqnav359sw7" />
      <circle cx="88" cy="70" r="17" fill="currentColor" opacity="0.22" data-id="element-27" data-mp="1iqq6j3skp5lz" />
      <circle cx="60" cy="24" r="12" fill="currentColor" opacity="0.3" data-id="element-28" data-mp="3hwri55bvu27z" />
    </svg>;
}

/** Silueta con puntos energéticos — decorativa. */
export function BodySilhouette({
  className = ''
}: DecorProps) {
  const points = [46, 66, 88, 110, 132];
  return <svg viewBox="0 0 80 200" fill="none" aria-hidden="true" className={className} data-id="element-29" data-mp="3ro5i1e7qx41n">
      <circle cx="40" cy="24" r="14" fill="currentColor" opacity="0.35" data-id="element-30" data-mp="hkrdvllry55" />
      <path d="M40 42c-14 0-22 8-22 22v34c0 8 2 14 5 20l-6 56c0 5 10 6 12 1l11-40 11 40c2 5 12 4 12-1l-6-56c3-6 5-12 5-20V64c0-14-8-22-22-22Z" fill="currentColor" opacity="0.24" data-id="element-31" data-mp="2yyf7ff5bokaa" />
      {points.map(y => <circle key={y} cx="40" cy={y} r="4.5" fill="currentColor" opacity="0.7" data-id="element-32" data-mp="38xo084ogbsv2" />)}
      <path d="M40 40v100" stroke="currentColor" strokeWidth="1.6" opacity="0.4" strokeDasharray="4 6" data-id="element-33" data-mp="3dsbivmwrxt1q" />
    </svg>;
}

/** Rama con hojas — decorativa. */
export function LeafSprig({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 120 200" fill="none" aria-hidden="true" className={className} data-id="element-34" data-mp="2dly6fu8qjq3j">
      <path d="M60 196V16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" data-id="element-35" data-mp="28n4rryhppt1s" />
      {[0, 1, 2, 3, 4].map(index => {
      const y = 44 + index * 30;
      return <g key={index} data-id="element-36" data-mp="23u1x1n178dk0">
            <path d={`M60 ${y} C40 ${y - 16} 20 ${y - 10} 12 ${y + 6} C30 ${y + 18} 50 ${y + 12} 60 ${y}Z`} fill="currentColor" opacity="0.35" data-id="element-37" data-mp="1yxto4rdlhgla" />
            <path d={`M60 ${y + 14} C80 ${y - 2} 100 ${y + 4} 108 ${y + 20} C90 ${y + 32} 70 ${y + 26} 60 ${y + 14}Z`} fill="currentColor" opacity="0.22" data-id="element-38" data-mp="1pw3xhnrjelok" />
          </g>;
    })}
      <circle cx="60" cy="16" r="7" fill="currentColor" opacity="0.5" data-id="element-39" data-mp="1g00ktnz274nd" />
    </svg>;
}

/** Mandala de integración — decorativo. */
export function Mandala({
  className = ''
}: DecorProps) {
  return <svg viewBox="0 0 100 100" fill="none" aria-hidden="true" className={className} data-id="element-40" data-mp="3ad04ptah2l0g">
      {Array.from({
      length: 8
    }, (_, index) => <ellipse key={index} cx="50" cy="24" rx="9" ry="20" fill="currentColor" opacity="0.32" transform={`rotate(${index * 45} 50 50)`} data-id="element-41" data-mp="2c0nufvrqj6u7" />)}
      <circle cx="50" cy="50" r="20" stroke="currentColor" strokeWidth="1.6" opacity="0.45" data-id="element-42" data-mp="22z6f4fm5j96k" />
      <circle cx="50" cy="50" r="8" fill="currentColor" opacity="0.7" data-id="element-43" data-mp="1oatidgf8pmb0" />
    </svg>;
}